module.exports = "/fonts/vendor/linearicons/dist/web-Linearicons-Free.eot?eb992e965197b4672140386c78da592f";